<template>
  <v-container fluid>
    <PcqDsisTable
      class="pb-4"
      :pcqDsiIsConfirm="pcqDsiIsConfirm"
    >
      <template v-slot:actions="{ dataset }">
        <avs-exportButton
          v-if="pcqDsiIsConfirm"
          :name="$t('actions.export_')"
          :spantext="
            $t('actions.export_to_word', {
              entity: $tc('categories.pcqdsi.name', 2).toLowerCase()
            })
          "
          @click="handleExportPcqDsi()"
        />
        <avs-validateButton
          v-if="!pcqDsiIsConfirm && dataset.length > 0"
          :data="dataset"
          :name="$t('actions.add', { entity: $tc('categories.pcqdsi.name', 1) })"
          :spantext="
            $t('actions.create', {
              entity: $tc('categories.pcqdsi.name', 1).toLowerCase()
            })
          "
          @click="handleOpenValidateDialog()"
        >
        </avs-validateButton>
        <avs-createButton
          v-if="!pcqDsiIsConfirm"
          :data="dataset"
          :name="$t('commons.add_pcq')"
          :spantext="
            $t('actions.create', {
              entity: $tc('categories.pcqdsi.name', 1).toLowerCase()
            })
          "
          @click="handleNewPcqDsi()"
        >
        </avs-createButton>
        <avs-confirmDialog
          v-model="confirmDialogIsOpen"
          @cancel="handleCancel"
          @confirm="handleConfirm"
        />
      </template>
    </PcqDsisTable>
  </v-container>
</template>
<script>
import PcqDsisTable from "@/components/ri3/pcqDsi/PcqDsisTable.vue"
import PcqDsiService from "@/services/PcqDsiService"
import { downloadRaw, getFilename } from "@/utils/download"

export default {
  name: "PcqDsisView",
  components: { PcqDsisTable },
  computed: {
    project() {
      return this.$store.state.app.project
    },
    pcqDsiIsConfirm() {
      return this.project.validated_pcq_dsi
    }
  },
  data() {
    return {
      loading: false,
      confirmDialogIsOpen: false
      // pcqDsiIsConfirm: false
    }
  },
  methods: {
    handleNewPcqDsi() {
      this.$router.push({
        name: "PcqDsiCreateUpdate"
      })
    },
    handleOpenValidateDialog() {
      this.confirmDialogIsOpen = true
    },
    handleCancel() {
      this.confirmDialogIsOpen = false
    },
    handleConfirm() {
      PcqDsiService.validate(this, this.project.id)
        .then(r => {
          // this.pcqDsiIsConfirm = true
          this.$store.commit("app/updateProjectValidation", { validated_pcq_dsi: true })
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.validate", {
              entity: this.$tc("categories.pcqdsi.name", 1)
            }),
            color: "success"
          })
          this.confirmDialogIsOpen = false
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
      this.deleteDialogIsOpen = false
    },

    handleExportPcqDsi() {
      PcqDsiService.wordExport(this, this.project.id)
        .then(data => {
          console.log(data)
          const blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          })
          const blobUrl = window.URL.createObjectURL(blob)
          //suppression du fichier temporaire
          const filename = getFilename("docx", "test")
          // this.loading = false
          downloadRaw(blobUrl, filename)
        })
        .catch(error => {
          this.loading = false
          this.$store.commit("app/message", {
            msg: `${this.$t("commons.error").toUpperCase()}: ${error.status}`,
            color: "error"
          })
        })
    }
  }
}
</script>
